// extracted by mini-css-extract-plugin
module.exports = {"button":"primarybutton_button__3u7rg","success":"primarybutton_success__1YIvK","fullWidth":"primarybutton_fullWidth__17T4M"};